import { defineAbility } from "@casl/ability";
import { MODULES, SIDEMENU_ITEMS } from "./permissions";

export function defineAbilitiesFor(user) {
  const { module, Service } = user || {};
  return defineAbility((can) => {

    // 1. If user has access to ALL modules
    if (module === MODULES.ALL && Service === MODULES.ALL) {
      can("manage", "all");
      Object.values(SIDEMENU_ITEMS).forEach((item) => can("view", item));
      return;
    }

    // 2. Normal module-based permissions
    switch (module) {
      case MODULES.INSPECTION_APP:
        can("view", SIDEMENU_ITEMS.INSPECTION);
        break;

      case MODULES.RESORT_BOOKING:
        can("view", SIDEMENU_ITEMS.RESORT);
        break;

      case MODULES.MAIN_SITE:
        can("view", SIDEMENU_ITEMS.MAIN_SITE);
        break;

      case MODULES.E_TICKETING:
        handleETicketingPermissions(can, user);
        break;

      default:
        break;
    }
  });
}


// ------------------------------
// ✔ E-Ticketing Permissions
// ------------------------------
function handleETicketingPermissions(can, user) {
  const { roles, Service, module } = user;

  const isGlobalSuperAdmin = roles === "Super Admin" && Service === "*" && module === "*";
  const isGlobalAdmin = roles === "Admin" && Service === "*" && module === "*";

  // -------------------------
  // 1️⃣ Super Admin / Admin with NO Service
  // -------------------------
  if (isGlobalSuperAdmin || isGlobalAdmin) {
    can("manage", "e-ticketing");

    // Show GENERAL e-ticketing menu
    can("view", SIDEMENU_ITEMS.E_TICKETING);

    // Show all service menus
    [
      SIDEMENU_ITEMS.CHAIRLIFT_AND_CABLE_CAR,
      SIDEMENU_ITEMS.SIGHTSEEING,
      SIDEMENU_ITEMS.BOATING,
      SIDEMENU_ITEMS.SOFTWHEEL_TRAIN
    ].forEach((item) => can("view", item));

    return;
  }

  // -------------------------
  // 2️⃣ Service-Based E-Ticketing Users
  // -------------------------
  if (Service && roles) {
    // Role-based access
    if (roles === "Admin") {
      can("manage", Service);
    } else {
      can("read", Service);
    }

    // Correct service-to-menu mapping
    const ETICKETING_SERVICE_TO_MENU = {
      "Patriata Chairlift": SIDEMENU_ITEMS.CHAIRLIFT_AND_CABLE_CAR,
      "Chair Lift and Cable Car": SIDEMENU_ITEMS.CHAIRLIFT_AND_CABLE_CAR,

      "Sight Seeing Service": SIDEMENU_ITEMS.SIGHTSEEING,
      "Boating Service": SIDEMENU_ITEMS.BOATING,
      "Soft Wheel Train Service": SIDEMENU_ITEMS.SOFTWHEEL_TRAIN,

      // Only shown for admin/super admin with NULL service
      "General e-ticketing": SIDEMENU_ITEMS.E_TICKETING,
    };

    const menu = ETICKETING_SERVICE_TO_MENU[Service];

    if (menu) {
      can("view", menu);
    }
  }
}
